import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * @typedef {"pending"|"accepted"|"in_progress"|"ready_for_driver"|"on_the_way"|"completed"|"cancelled"} OrderStatus
 */

export const updateOrderStatus = async (restaurantId, orderId, newStatus, extraUpdates = {}) => {
  if (!restaurantId || !orderId) return;
  const ref = doc(db, "orders", orderId);
  await updateDoc(ref, {
    status: newStatus,
    updatedAt: serverTimestamp(),
    ...(extraUpdates || {}),
  });
};